<template>
  <v-app>
    <v-app-bar v-if="
      $route.path != '/' &&
      $route.path != '/forgotPassword' &&
      $route.path != '/register'
    " app color="white" dark>
      <v-row class="ma-0">
        <v-col class="pa-0" cols="3" sm="6" md="6">
          <v-row justify="start" class="ma-0">
            <v-app-bar-nav-icon class="black-color" @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="black-color mt-2 mx-4 hidden-sm-and-down">{{
              $route.name
            }}</v-toolbar-title>
          </v-row>
        </v-col>
        <v-col class="pa-0" cols="9" sm="6" md="6">
          <v-row justify="center" justify-sm="end" class="ma-0">
            <v-icon v-if="storeUser && storeUser.userType == 'Admin'" @click="$router.push('/notifications')"
              class="black-color mt-1">mdi-bell</v-icon>
            <h3 v-if="storeUser && storeUser.name" class="mt-2 mx-4" style="color: grey">
              {{ storeUser.name + " " + storeUser.surname }}
            </h3>
            <h3 v-if="storeUser && storeUser.companyName" class="mt-2 mx-4" style="color: grey">
              {{ storeUser.companyName }}
            </h3>
            <v-icon class="mt-1" style="color: grey" large>mdi-account</v-icon>
          </v-row>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="black" dark depressed large style="border-radius: 24px" @click="promptDialog = false">
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer v-if="
      $route.path != '/' &&
      $route.path != '/forgotPassword' &&
      $route.path != '/register'
    " class="nav-drawer pr-4" app v-model="drawer">
      <v-row justify="center">
        <img height="150px" class="my-8" src="./assets/images/logo.png" alt="" />
      </v-row>
      <v-row v-if="storeUser.userType == 'Admin' && storeUser.adminType == 'Super Admin'" class="ma-0 pl-8 py-2 pointer" @click="$router.push('/home')"
        :class="{ activeRoute: $route.path == '/home' }">
        <v-icon color="#4390c0"> mdi-apps </v-icon>
        <p class="mx-3">Dashboard</p>
      </v-row>
      <v-row class="ma-0 pl-8 py-2 pointer" @click="$router.push('/userManagement')"
        :class="{ activeRoute: $route.path == '/userManagement' }">
        <v-icon color="#4390c0"> mdi-account-group </v-icon>
        <p class="mx-3">User Management</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/clientManagement')" :class="{ activeRoute: $route.path == '/clientManagement' }">
        <v-icon color="#4390c0"> mdi-account-group </v-icon>
        <p class="mx-3">Client Management</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/clientCompanies')" :class="{ activeRoute: $route.path == '/clientCompanies' }">
        <v-icon color="#4390c0"> mdi-domain </v-icon>
        <p class="mx-3">Client Companies</p>
      </v-row>
      <!-- <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer" @click="$router.push('/pendingDoctors')"
        :class="{ activeRoute: $route.path == '/pendingDoctors' }">
        <v-icon color="#4390c0"> mdi-doctor </v-icon>
        <p class="mx-3">Pending Doctors</p>
      </v-row> -->
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/doctorUpdates')" :class="{ activeRoute: $route.path == '/doctorUpdates' }">
        <v-icon color="#4390c0"> mdi-update </v-icon>
        <p class="mx-3">Update Requests</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/clearanceRequests')" :class="{ activeRoute: $route.path == '/clearanceRequests' }">
        <v-icon color="#4390c0"> mdi-check-circle </v-icon>
        <p class="mx-3">Clearance Requests</p>
      </v-row>
      <v-row
        v-if="storeUser && storeUser.userType == 'Admin' && storeUser.adminType == 'Super Admin'"
        class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/dataDeletionRequests')"
        :class="{ activeRoute: $route.path == '/dataDeletionRequests' }"
      >
        <v-icon color="#4390c0"> mdi-trash-can </v-icon>
        <p class="mx-3">Data Deletion</p>
      </v-row>
      <v-row
        v-if="storeUser && storeUser.userType == 'Admin'"
        class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/abuseReports')"
        :class="{ activeRoute: $route.path == '/abuseReports' }"
      >
        <v-icon color="#4390c0"> mdi-shield-alert </v-icon>
        <p class="mx-3">Abuse Reports</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/activity')" :class="{ activeRoute: $route.path == '/activity' }">
        <v-icon color="#4390c0"> mdi-chart-line-variant </v-icon>
        <p class="mx-3">Activity</p>
      </v-row>
      <!-- <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/refunds')" :class="{ activeRoute: $route.path == '/refunds' }">
        <v-icon color="#4390c0"> mdi-cash-refund </v-icon>
        <p class="mx-3">Refund Requests</p>
      </v-row> -->
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/manageAds')" :class="{ activeRoute: $route.path == '/manageAds' }">
        <v-icon color="#4390c0"> mdi-shape-square-plus </v-icon>
        <p class="mx-3">Manage Ads</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/manageArticles')" :class="{ activeRoute: $route.path == '/manageArticles' }">
        <v-icon color="#4390c0"> mdi-file-document-edit</v-icon>
        <p class="mx-3">Manage Articles</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/manageProducts')" :class="{ activeRoute: $route.path == '/manageProducts' }">
        <v-icon color="#4390c0"> mdi-application-cog</v-icon>
        <p class="mx-3">Manage Products</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/subscriptions')" :class="{ activeRoute: $route.path == '/subscriptions' }">
        <v-icon color="#4390c0"> mdi-playlist-check</v-icon>
        <p class="mx-3">Subscriptions</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/manageRefunds')" :class="{ activeRoute: $route.path == '/manageProducts' }">
        <v-icon color="#4390c0"> mdi-cash-refund</v-icon>
        <p class="mx-3">Manage Refunds</p>
      </v-row>
       <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/manageOrders')" :class="{ activeRoute: $route.path == '/manageOrders' }">
        <v-icon color="#4390c0"> mdi-format-list-numbered</v-icon>
        <p class="mx-3">Manage Orders</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/groups')" :class="{ activeRoute: $route.path == '/groups' }">
        <v-icon color="#4390c0"> mdi-account-multiple</v-icon>
        <p class="mx-3">Manage Groups</p>
      </v-row>
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/reportedMessages')" :class="{ activeRoute: $route.path == '/reportedMessages' }">
        <v-icon color="#4390c0"> mdi-alert</v-icon>
        <p class="mx-3">Reported Messages</p>
      </v-row>
      <!-- <v-row
        v-if="storeUser.userType == 'Admin'"
        class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/orderHistory')"
        :class="{ activeRoute: $route.path == '/orderHistory' }"
      >
        <v-icon color="#4390c0"> mdi-list-box </v-icon>
        <p class="mx-3">Order History</p>
      </v-row> -->
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/auditTrail')" :class="{ activeRoute: $route.path == '/auditTrail' }">
        <v-icon color="#4390c0"> mdi-text-search </v-icon>
        <p class="mx-3">Audit Trail</p>
      </v-row>
      <!-- <v-row
        v-if="storeUser.userType == 'Admin'"
        class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/documents')"
        :class="{ activeRoute: $route.path == '/documents' }"
      >
        <v-icon color="#4390c0"> mdi-file-document </v-icon>
        <p class="mx-3">Documents</p>
      </v-row> -->
      <v-row v-if="storeUser && storeUser.userType == 'Admin'" class="ma-0 pl-8 py-2 pointer"
        @click="$router.push('/notifications')" :class="{ activeRoute: $route.path == '/notifications' }">
        <v-icon color="#4390c0"> mdi-bell </v-icon>
        <p class="mx-3">Notifications</p>
      </v-row>
      <v-row @click="logout()" class="ma-0 pl-8 py-2 pointer">
        <v-icon color="#4390c0"> mdi-logout </v-icon>
        <p class="mx-3">Logout</p>
      </v-row>
    </v-navigation-drawer>
    <notifications :closeOnClick="true" group="alert" position="bottom center" :duration="100000" />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { auth } from "../firebaseConfig.js";
import {
  onAuthStateChanged,
} from "firebase/auth";

import { getUserProfileByAuth, logAction } from "@/utils/firestoreUtil";

export default {
  name: "App",
  data: () => ({
    drawer: null,
    user: null,
    email: null,
    loading: false,
    promptDialog: false,
    promptMessage: "",
    promptType: "",
  }),
  created() {
    onAuthStateChanged(auth, (user) => {
      // this.$store.commit("setAuthUser", user);
      if (user) {
        this.email = user.email;
        console.log("Auth User: ", this.email);

        this.initUser();
      }
    });
  },
  methods: {
    async initUser() {
      try {
        const authUser = auth.currentUser;
        const tempUser = await getUserProfileByAuth({
          email: this.email || (authUser && authUser.email),
          uid: authUser && authUser.uid,
        });

        if (tempUser) {
          if (!tempUser.email && authUser && authUser.email) {
            tempUser.email = authUser.email;
          }
          this.$store.commit("setUser", tempUser);
          return;
        }

        // C) No matching user found
        this.loading = false;
        this.promptMessage = "No account found for that email.";
        this.promptType = "error";
        this.promptDialog = true;
        await auth.signOut();
      } catch (error) {
        console.error("Error initializing user:", error);
        await auth.signOut();
      }
    },
    async logout() {
      try {
        await logAction("Login/Logout", "Logged Out", this.storeUser.email, this.storeUser.email + " has logged out of the dashboard");

        this.loading = true;
        let logoutRes = await auth.signOut();
        this.loading = false;

        this.promptMessage = "Logged out successfully!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.promptDialog = false;
          this.$router.push({ path: "/" });
          this.$router.go();
        }, 3000);
      } catch (error) {
        this.loading = false;
        this.promptMessage =
          "An error occured while logging out, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
  },
  computed: {
    storeUser() {
      return this.$store.state.user;
    },
  },
};
</script>

<style>
.white-color {
  color: white !important;
}

.blue-color {
  color: #4390c0 !important;
}

.pink-color {
  color: #e022d1 !important;
}

.pink-btn {
  background-color: #e022d1;
}

.blue-btn {
  background-color: #4390c0;
}

.black-color {
  color: black !important;
}

.grey-color {
  color: grey !important;
}

.nav-drawer {
  border-radius: 0px 15px 15px 0px;
  background-image: url("./assets/images/nav-background.png");
  background-size: cover;
}

.nav-drawer p {
  font-weight: 500;
}

.activeRoute {
  border-radius: 0px 15px 15px 0px;
  background-color: #4390c0 !important;
}

.activeRoute .v-icon {
  color: white !important;
}

.activeRoute p {
  color: white !important;
}

p {
  margin: 0px !important;
}

.pointer {
  cursor: pointer;
}

.fs400 {
  font-weight: 400;
}

.fs700 {
  font-weight: 700 !important;
}

.inset {
  width: 250px;
  height: 30px;
  background: #dfe0e8 0% 0% no-repeat padding-box;
  box-shadow: 1px 1px 16px lightgrey;
  border-radius: 21px;
  color: black;
  font-weight: 500;
  font-size: 12px;
}

.white-card {
  width: 100%;
  border-radius: 15px;
  box-shadow: 1px 1px 16px lightgrey;
  background-color: white;
}

.blue-card {
  width: 100%;
  border-radius: 15px;
  box-shadow: 1px 1px 16px lightgrey;
  background: linear-gradient(to bottom, #4390c0, black);
}

thead {
  background-color: #414141 !important;
}

th span {
  color: white !important;
}

.v-data-table tr:nth-child(even) {
  background-color: lightgrey !important;
}

.v-input__slot:after {
  display: none !important;
}

.v-input__slot:before {
  display: none !important;
}

.input .v-input__slot {
  background: linear-gradient(to bottom, lightgrey, white) 0% 0% no-repeat padding-box !important;
  border: 1px solid lightgrey !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.selected {
  background-color: #e022d1 !important;
  color: white !important;
}

.selected h4 {
  color: white !important;
}

::-webkit-scrollbar {
  height: 12px;
  width: 12px;
  background: white;
  border-radius: 25px;
}

::-webkit-scrollbar-thumb {
  background: #4390c0;
  -webkit-border-radius: 1ex;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
}

::-webkit-scrollbar-corner {
  background: #000;
}

td {
  font-weight: 500 !important;
}

.relative {
  position: relative !important;
}

.capatilize {
  text-transform: capitalize;
}

.v-select__selection {
  text-transform: capitalize !important;
}

.doctorMessage {
  background: linear-gradient(to right, black, #e022d1) !important;
  color: white !important;
}

.doctorMessage .v-icon {
  color: white !important;
}

.doctorMessage h5 {
  color: white !important;
}

.doctorMessage .bar {
  background: white !important;
}
</style>


